var map = {
	"./close.png": 460,
	"./help.png": 448,
	"./info.png": 548,
	"./like.png": 159,
	"./music-note.png": 860,
	"./pause_btn.png": 90,
	"./play_btn.png": 952,
	"./search_icon.png": 95,
	"./skipped.png": 620,
	"./spotify.png": 315,
	"./volume.png": 988,
	"./wrong.png": 960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;